<template>
    <!-- Intro-->
    <section class="section section-custom-1 bg-img-1 section-intro">
        <div class="container">
            <div class="row">
                <div class="col-md-7 col-xl-6 text-start position-relative">
                    <div class="text-big text-decorative text-primary wow fadeInLeft">Delicious</div>
                    <h3 class="wow fadeInLeft fw-bold text-decor-line text-spacing-200" data-wow-delay=".2s">Eggless & Vegan</h3>
                    <h4 class="wow fadeInLeft text-spacing-100 text-transform-none text-gray-600 fw-normal text-gray-600" data-wow-delay=".3s"><span class="d-xl-block">We invite you to join us on this </span><span class="d-xl-block">new journey for a delicious and healthy lifestyle.</span></h4>
                    <router-link class="button button-lg button-shadow-2 button-primary button-zakaria wow fadeInUp" to="/our-menu">Shop now</router-link>
                </div>
            </div>
        </div>
    </section>

    <!-- Promo-->
    <section class="section section-sm bg-default pt-xl-0">
    <div class="container">
        <article class="promo-classic offset-negative-1">
        <div class="promo-classic-title">Only Fresh Cakes</div>
        <p class="big promo-classic-text">All of our products are made from scratch using family recipes with only the highest quality ingredients.  We bake and sell fresh daily to ensure only the best products are sold to our customers.</p>
        <router-link class="button button-sm button-icon-3 button-primary button-zakaria" to="/our-menu"><span class="mdi mdi-arrow-right"></span></router-link>
        </article>
    </div>
    </section>

    <!-- About Us-->
    <section class="section section-sm section-last bg-default">
        <div class="container">
            <h2 class="wow fadeScale">What We offer</h2>
            <!-- Owl Carousel-->
            <div class="owl-carousel owl-style-8" data-items="1" data-sm-items="2" data-lg-items="3" data-margin="30" data-dots="true" data-mouse-drag="false">
            <article class="box-info-modern wow slideInUp" data-wow-delay=".1s"><a class="box-info-modern-figure" href="#"><img src="/assets/images/standard_cakes.png" alt="" width="340" height="243"/></a>
                <h4 class="box-info-modern-title"><a href="#">Standard cakes</a></h4>
                <div class="box-info-modern-text">Made with high-quality ingredients and baked fresh daily, these cakes are perfect for any occasion.</div>
                <router-link class="box-info-modern-link" :to="{ path: '/our-menu', query: { category: 'standard-cakes' } }">Shop Now</router-link>
            </article>
            <article class="box-info-modern wow slideInUp"><a class="box-info-modern-figure" href="#"><img src="/assets/images/exotic_cakes.png" alt="" width="340" height="243"/></a>
                <h4 class="box-info-modern-title"><a href="#">Exotic cakes</a></h4>
                <div class="box-info-modern-text">Made with unique flavors and the best ingredients, these cakes are sure to please any palate.</div>
                <router-link class="box-info-modern-link" :to="{ path: '/our-menu', query: { category: 'exotic-cakes' } }">Shop Now</router-link>
            </article>
            <article class="box-info-modern wow slideInUp" data-wow-delay=".1s"><a class="box-info-modern-figure" href="#"><img src="/assets/images/premium_cakes.png" alt="" width="340" height="243"/></a>
                <h4 class="box-info-modern-title"><a href="#">Premium cakes</a></h4>
                <div class="box-info-modern-text">Premium cakes are made with the best ingredients and are always available at our bakery.</div>
                <router-link class="box-info-modern-link" :to="{ path: '/our-menu', query: { category: 'premium-cakes' } }">Shop Now</router-link>
            </article>
            </div>
        </div>
    </section>

    <!-- New products-->    

    <!-- CTA-->
    <section class="section parallax-container">
        <div class="material-parallax parallax">
            <img src="/assets/images/custom_cakes_1.png" alt="banner image" style="transform: translate3d(-50%, 31px, 0px); display: block;">
        </div>
        <div class="parallax-content section-xxl context-light text-md-start bg-overlay-1">
            <div class="container box-cta">
            <h2 class="wow fadeInRight pb-xl-0">Custom Cakes</h2>
            <div class="group-md-2 group-middle wow fadeInRight" data-wow-delay=".1s"><span class="text-lg title-style-6"></span><span class="heading-4 fw-sbold"></span></div>
            <p class="text-width-medium wow fadeInRight" data-wow-delay=".2s">We offer a wide range of custom cakes for all occasions. Whether you need a birthday cake, wedding cake, or any other special occasion cake, we have you covered.</p>
            <router-link class="button button-lg button-shadow-2 button-secondary button-zakaria wow fadeInUp" to="/custom-cake-category">Shop now</router-link>
            </div>
        </div>
    </section>

    <!-- Our Stores-->
    <section class="section section-xxl bg-image-1">
        <div class="container">
            <h2 class="wow fadeScale">Our Stores</h2>
            <!-- Owl Carousel-->
            <div class="owl-carousel owl-style-10" data-items="1" data-sm-items="2" data-lg-items="3" data-margin="30" data-dots="true" data-mouse-drag="false">
            <article class="team-creative wow slideInUp" data-wow-delay=".1s">
                <div class="team-creative-header"><a class="team-creative-figure" href="/contact-us"><img src="/assets/images/truganina.jpg" alt="CakeGurus Truganina" style="width: 249px; height: 249px; object-fit: cover;"/></a>
                <div class="team-creative-decor"></div>
                </div>
                <div class="team-creative-body">
                <h4 class="team-creative-name"><a href="/contact-us">CakeGurus Truganina</a></h4>
                <p class="team-creative-text">
                    Shop 16, 211 Leakes Rd, Truganina VIC 3029<br/>
                    <a href="mailto:info@cakegurus.com.au">info@cakegurus.com.au</a><br/>
                    <a href="tel:0423644818">0423 644 818</a>, <a href="tel:0393941681">03 9394 1681</a><br/>
                    7 days (10am - 9pm)
                </p>
                </div>
            </article>
            <article class="team-creative wow slideInUp">
                <div class="team-creative-header"><a class="team-creative-figure" href="/contact-us"><img src="/assets/images/melbourne.jpg" alt="CakeGurus Cranbourne" style="width: 249px; height: 249px; object-fit: cover;"/></a>
                <div class="team-creative-decor"></div>
                </div>
                <div class="team-creative-body">
                <h4 class="team-creative-name"><a href="/contact-us">CakeGurus Cranbourne</a></h4>
                <p class="team-creative-text">
                    14 Lurline Street, Cranbourne VIC 3977<br/>
                    <a href="mailto:info@cakegurus.com.au">info@cakegurus.com.au</a><br/>
                    <a href="tel:0412401771">0412 401 771</a>, <a href="tel:0359953490">03 5995 3490</a><br/>
                    7 days (11am - 8pm)
                </p>
                </div>
            </article>
            <article class="team-creative wow slideInUp" data-wow-delay=".1s">
                <div class="team-creative-header"><a class="team-creative-figure" href="/contact-us"><img src="/assets/images/epping.jpg" alt="CakeGurus Epping" style="width: 249px; height: 249px; object-fit: cover;"/></a>
                <div class="team-creative-decor"></div>
                </div>
                <div class="team-creative-body">
                <h4 class="team-creative-name"><a href="/contact-us">CakeGurus Epping</a></h4>
                <p class="team-creative-text">
                    Shop 3, 145 Gateway boulevard, Epping, VIC - 3076<br/>
                    <a href="mailto:info@cakegurus.com.au">info@cakegurus.com.au</a><br/>
                    <a href="tel:0416300460">0416 300 460</a><br/>
                    6 days (11am - 8pm) (Monday Closed)
                </p>
                </div>
            </article>
            </div>
        </div>
    </section>

    <!-- CTA 2-->
    <section class="section section-xxl section-inset-1 bg-image" style="background-image: url(/assets/images/banner_section_2.png);">
        <div class="container box-cta">
            <h3 class="fw-normal text-transform-none wow fadeInDown text-decorative text-primary text-spacing-75">Unique Flavors and Fresh Ingredients</h3>
            <h2 class="text-spacing-75 text-black-800 wow fadeScale">All Kinds of Cakes</h2>
            <router-link class="button button-lg button-primary button-zakaria wow fadeInUp" to="/our-menu">Shop Now</router-link>
        </div>
    </section>

    <!-- Latest News-->
    <!-- <section class="section section-xxl bg-image-1">
        <div class="container">
            <h2 class="wow fadeScale">Latest News</h2>
            <div class="row row-lg row-30 justify-content-center">
            <div class="col-sm-8 col-md-6 wow fadeInLeft">
                <article class="post post-nikki post-nikki-2">
                <div class="post-nikki-figure"><img src="/assets/images/post-1-570x461.jpg" alt="" width="570" height="461"/>
                </div>
                <div class="post-nikki-body">
                    <div>
                    <div class="post-nikki-time">
                        <time datetime="2023-09-08">August 9, 2023</time>
                    </div>
                    <div class="post-nikki-title"><a href="#">How to Pipe a Fluffy Frosting Border on a Cake</a></div>
                    </div>
                </div>
                </article>
            </div>
            <div class="col-md-6">
                <div class="row row-30">
                <div class="col-6 col-md-12 wow fadeInRight">
                    <article class="post post-nikki">
                    <div class="unit unit-spacing-lg flex-column flex-md-row align-items-center">
                        <div class="unit-left"><a class="post-nikki-figure" href="#"><img src="/assets/images/post-2-270x215.jpg" alt="" width="270" height="215"/></a></div>
                        <div class="unit-body">
                        <div class="post-nikki-time">
                            <time datetime="2023-09-08">August 9, 2023</time>
                        </div>
                        <div class="post-nikki-title"><a href="#">Recipe of the Day: Pumpkin Spice Latte Cake</a></div>
                        </div>
                    </div>
                    </article>
                </div>
                <div class="col-6 col-md-12 wow fadeInRight">
                    <article class="post post-nikki">
                    <div class="unit unit-spacing-lg flex-column flex-md-row align-items-center">
                        <div class="unit-left"><a class="post-nikki-figure" href="#"><img src="/assets/images/post-3-270x215.jpg" alt="" width="270" height="215"/></a></div>
                        <div class="unit-body">
                        <div class="post-nikki-time">
                            <time datetime="2023-09-08">August 9, 2023</time>
                        </div>
                        <div class="post-nikki-title"><a href="#">Top 5 Tips for Successful Cake Baking</a></div>
                        </div>
                    </div>
                    </article>
                </div>
                </div>
            </div>
            </div>
        </div>
    </section> -->


</template>

<script setup>
import { onMounted } from 'vue'
import { useHead } from '@unhead/vue'
import { useCartStore } from '@/stores/cart'

const cartStore = useCartStore()

useHead({
  title: 'CakeGurus',
  meta: [
    {
      name: 'description',
      content: 'Welcome to CakeGurus.',
    },
  ],
})

onMounted(() => {
    cartStore.loadCart()
    
    const scriptId = 'script-js-script'

    // Check if the script already exists
    const existingScript = document.getElementById(scriptId)

    if (existingScript) {
        // Replace it: remove and re-add
        existingScript.remove()
    }

    // Create and append a fresh script
    const newScript = document.createElement('script')
    newScript.src = '/assets/js/script.js'
    newScript.id = scriptId
    document.body.appendChild(newScript)
})
</script>
